const map = {
	"./ico-service-design-art.webp": 51912,
	"./ico-service-design-branding.webp": 36940,
	"./ico-service-design-design.webp": 52869,
	"./ico-service-design-wireframing.webp": 17480,
	"./logo-adobe-ai.webp": 98642,
	"./logo-adobe-ps.webp": 40949,
	"./logo-balsamiq-box.webp": 82490,
	"./logo-balsamiq.webp": 97778,
	"./logo-blender.webp": 85106,
	"./logo-canva.webp": 57345,
	"./logo-coreldraw.webp": 31385,
	"./logo-eraserio-box.webp": 65006,
	"./logo-excalidraw-box.webp": 87586,
	"./logo-excalidraw.webp": 85834,
	"./logo-figma-box.webp": 38370,
	"./logo-figma.webp": 55274,
	"./logo-invision.webp": 96977,
	"./logo-procreate.webp": 62105
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30680;